import React from 'react';

import { FormattedMessage, useIntl } from 'react-intl';

import Accordion from '@/components/UI/Accordion';
import { KycType } from '@lucky7ventures/bff-types';
import { TranslatedRichText } from '@/components/TranslatedRichText';
import { envIsCanada, envIsMexico } from '@/constants/constants';

const KycDescription = ({ kycType }: { kycType: KycType }) => {
  const intl = useIntl();

  switch (kycType) {
    case KycType.ProofOfAddress:
      return (
        <FormattedMessage
          id="settings.verify.proofOfAddress.text"
          values={{
            p: str => <p className="m-0">{str}</p>,
          }}
        />
      );
    case KycType.PaymentMethod:
      return (
        <FormattedMessage
          id="settings.verify.paymentMethod.text"
          values={{
            p: str => <p className="m-0">{str}</p>,
            em: str => <em className="m-0">{str}</em>,
          }}
        />
      );
    case KycType.SourceOfFunds:
      return (
        <>
          <FormattedMessage
            id="verify.SOF.desc"
            values={{
              div: content => <div className="flex flex-col gap-4">{content}</div>,
              ol: list => <ol className="list-decimal pl-4">{list}</ol>,
              li: str => <li className="font-bold m-0">{str}</li>,
              p: str => <p className="m-0">{str}</p>,
            }}
          />
          {(envIsMexico() || envIsCanada()) && (
            <>
              <Accordion header={intl.formatMessage({ id: 'verify.SOF.accordion.payslip.title' })}>
                {intl.formatMessage({ id: 'verify.SOF.accordion.payslip.text' })}
              </Accordion>
              <Accordion
                header={intl.formatMessage({ id: 'verify.SOF.accordion.bankStatement.title' })}
              >
                {intl.formatMessage({ id: 'verify.SOF.accordion.bankStatement.text' })}
              </Accordion>
              <Accordion
                header={intl.formatMessage({ id: 'verify.SOF.accordion.salesAgreement.title' })}
              >
                {intl.formatMessage({ id: 'verify.SOF.accordion.salesAgreement.text' })}
              </Accordion>
              <Accordion
                header={intl.formatMessage({
                  id: 'verify.SOF.accordion.inheritanceAgreement.title',
                })}
              >
                {intl.formatMessage({ id: 'verify.SOF.accordion.inheritanceAgreement.text' })}
              </Accordion>
              <Accordion
                header={intl.formatMessage({ id: 'verify.SOF.accordion.otherDocument.title' })}
              >
                {intl.formatMessage({ id: 'verify.SOF.accordion.otherDocument.text' })}
              </Accordion>
            </>
          )}
        </>
      );
    case KycType.Id:
      if (envIsMexico()) {
        return (
          <FormattedMessage
            id="settings.verify.photoId.mexico.intro"
            values={{
              div: content => <div className="flex flex-col gap-4">{content}</div>,
              ol: list => <ol className="list-decimal pl-4">{list}</ol>,
              li: str => <li className="font-bold m-0">{str}</li>,
              p: str => <p className="m-0">{str}</p>,
            }}
          />
        );
      }

      return <TranslatedRichText id="settings.verify.photoId.text" tagName="div" />;
    default:
      return null;
  }
};

export default KycDescription;
